import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, useLocation } from "react-router-dom";
import {
    Container,
    Content,
    Button,
    VStack,
    Divider,
    Heading, HeadingGroup, Text
  } from 'rsuite';
  import { MdOutlineLogin } from "react-icons/md";

  import './css/login.css';

const Login = () => {
  const { loginWithRedirect, isAuthenticated, error } = useAuth0();
  const location = useLocation();


  const handleLogin = async () => {
    await loginWithRedirect({
      prompt: "login",
      appState: {
        returnTo: location.state?.from?.pathname || "/b2b", // Default to "/b2b" if no prior location
      },
    });
  };

  const originalPath = window.location.pathname;


  if (isAuthenticated) {
    // Redirect to the intended route or main menu
   
    const redirectTo = originalPath || "/b2b";
    return <Navigate to={redirectTo} />;
  }

  if (error) {
    return <Navigate to="/403" />;
  }

  return (
    <Container className="login-div">
      <Content className="login-div-inner">
        <VStack alignItems="center" justifyContent="center" style={{ height: '100%' }}>
        <HeadingGroup>
        <Heading level={1} style={{color: "white"}}>Mobility Insights</Heading>
        <Heading level={3} style={{color: "white"}}>AI-Driven Smart Mobility Planning</Heading>
        <Button startIcon={<MdOutlineLogin />} appearance="default" active onClick={handleLogin}> Login </Button>
        <Divider />
        <Heading level={6} style={{color: "white"}}>Powered by 42hacks & Swisscom</Heading>
        </HeadingGroup>
        </VStack>
      </Content>
    </Container>
  );
};

export default Login;
